<template>
    <div class="invoice">
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="overflow: hidden">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">使用记录</div>
                        <div class="manage-invoice-hotel">
                        	<div class="time">
                                <span class="input-label">日期选择：</span>
                                <input type="text" class="date-time" v-model="Start" @click="calendar.show=true" data-type="time" readonly>
                                 -
                                <input type="text" class="date-time" v-model="End" @click="calendar.show=true" data-type="time" readonly>
                                <DatePicker @select="calendar.select" v-show="calendar.show" :start="calendar.start"
                                            :beginDate="calendar.begin" :last="calendar.last" :endDate="calendar.end" >
                                </DatePicker>
                                <span class="timeExcel" @click="export2Excel">导出</span>
                                <span class="timeSearch" @click="getReceiptData(true)">搜索</span>
                            </div>
                        </div>
                        <div class="invoice-table-box">
                            <table class="invoice-table">
                                <thead>
                                <tr>
                                    <td width="15%">订单编号</td>
                                    <td width="35%">酒店名称/房型</td>
                                    <!-- <td width="15%">房型</td> -->
                                    <td width="10%">客人名</td>
                                    <td width="10%">入/离时间</td>
                                    <td width="10%">创建时间</td>
                                    <td width="10%">使用金额</td>
                                    <!-- <td width="10%">余额</td> -->
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading && ReceiptList.length > 0">
                                <tr v-for="item in ReceiptList" >
                                    <td width="15%">{{item.OrderNO}}</td>
                                    <td width="35%">
                                        <div class="ellipsis" v-html="item.OrderInfo.match(/酒店名：(.+?);/g).toString().slice(4,-1)"></div>
                                        <div class="ellipsis" style="color:#555;" v-if="item.OrderInfo.match(/房型：(.+?)<br/g)" v-html="item.OrderInfo.match(/房型：(.+?)<br/g).toString().slice(3,-3)"></div>
                                        <div class="ellipsis" style="color:#555;" v-else v-html="'暂无'"></div>
                                    </td>
                                    <!-- <td width="15%" v-if="item.OrderInfo.match(/房型：(.+?)<br/g)" v-html="item.OrderInfo.match(/房型：(.+?)<br/g).toString().slice(3,-3)"></td> -->
                                    <!-- <td width="15%" v-else v-html="'无'"></td> -->
                                    <td width="10%" v-html="item.OrderInfo.match(/客人名：(.+?);/g).toString().slice(4,-1)"></td>
                                    <td width="10%">
                                        <span v-html="item.OrderInfo.match(/入住时间：(.+?);/g).toString().slice(5,-1)"></span><br>
                                        <span v-html="item.OrderInfo.match(/离店时间：(\S*)/g).toString().slice(5)"></span></td>
                                    <td width="10%">
                                        <span>{{item.CreationDate|dateToYMDline}}</span><br>
                                        <span>{{item.CreationDate|dateline}}</span>
                                    </td>
                                    <td width="10%">{{(item.UseNum).toFixed(2)}}</td>
                                    <!-- <td width="10%">{{(item.BalanceNum).toFixed(2)}}</td> -->
                                </tr>
                                </tbody>
                                <tbody v-else>
                                <tr>
                                    <td align="center" style="vertical-align: middle" colspan="9">
                                        <div v-if="isLoading">
                                            <Loading :isLoading="isLoading"></Loading>
                                        </div>
                                        <div v-else>{{noneDataMsg}}</div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                           <div class="Page">
                                <span @click="handlePrev" class="PageBtn">上一页</span>
                                <span class="PageNumber">第{{curPage}}页/共{{allPage}}页</span>
                                <span @click="handleNext" class="PageBtn">下一页</span>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from './../../common/cmpnt/menu/Menu'
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import DatePicker from './datePicker.vue'//日期
    import { log } from 'util';

    export default {
        name: "ReceiptsBill",
        components: {
            Menu,
            Loading,
            DatePicker
        },
        data() {
            return {
                ReceiptList: [],
                isLoading:true,
                noneDataMsg:'',//无数据
                End: this.getDate(0),
                Start: this.getDate(-90),
                //分页
                allPage: '', //总页数
                curPage: 1, //当前页码
                pageSize: 8, //每页展示数量
                calendar: {
                    show: false,
                    start: '',
                    last: this.getDate(0),
                    begin: this.getDate(-90),
                    end: this.getDate(0),
                    select: (begin, end) => {
                        if (!begin) {
                            this.calendar.show = false;
                            this.calendar.begin = this.Start;
                            this.calendar.end = this.End;
                            return;
                        }
                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.Start = begin;
                        this.End = end;
                        this.$nextTick(function () {
                            this.calendar.show = false;
                        });
                    }
                },
            }
        },
        watch:{},
        computed:{},
        mounted() {
            document.title = '使用记录'
            this.getReceiptData()
            
            
        },
        methods: {
            export2Excel() {
                let that = this
                that.getReceiptData(true)
                let param = {
                    Page: 1,
                    PageSize: 9999,
                    End: this.End,
                    Start: this.Start
                }
                that.isLoading = true
                //  发请求
                that.postRequest({
                    //  请求的url   api文件里面写的
                    url:that.Api.getReceipts,
                    params:param
                }).then(res => {
                    if(res.IsSuccess){
                        //  如果成功了
                        that.isLoading = false
                        require.ensure([], () => {
                            const { export_json_to_excel } = require('../../common/excel/Export2Excel'); //这里必须使用绝对路径
                            const tHeader = ['订单编号','客户订单号','订单类型','酒店名称','房型','间夜数','客人名','入住时间','离店时间','创建时间','使用金额']; // 导出的表头名
                            const filterVal = ['OrderNO','ThirdOrderNO','OrderType','HotelName','RoomType','RoomCount','User','CheckIn','CheckOut','CreationDate','UseNum']; // 导出的表头字段名
                            const list = that.tableExcelData(res.Result);
                            const data = that.formatJson(filterVal, list);
                            export_json_to_excel(tHeader, data, '使用记录');// 导出的表格名称，根据需要自己命名
                        })

                        if(!res.Total){ 
                            that.noneDataMsg='暂无数据...'
                        }else{
                            that.noneDataMsg=''
                        }
                    }else{
                        //  如果失败了
                        this.error({title:'提示',content:res.Msg||'保存失败'});
                    }
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            tableExcelData(list){
                var l = [];
                for(let i=0; i<list.length; i++){
                    var RoomType = list[i].OrderInfo.match(/房型：(.+?)<br/g)
                    if(RoomType){
                        RoomType = RoomType.toString().slice(3,-3)
                    }else{
                        RoomType = '无'
                    }
                    var CheckIn = list[i].OrderInfo.match(/入住时间：(.+?);/g).toString().slice(5,-1)
                    var CheckOut = list[i].OrderInfo.match(/离店时间：(\S*)/g).toString().slice(5)

                    var lis = {
                        OrderNO:list[i].OrderNO,
                        ThirdOrderNO:list[i].ThirdOrderNO,
                        OrderType:list[i].UseNum>=0?'正常':'取消',
                        HotelName:list[i].OrderInfo.match(/酒店名：(.+?);/g).toString().slice(4,-1),
                        RoomType:RoomType,
                        RoomCount:this.getDays(CheckIn,CheckOut)||'',
                        User:list[i].OrderInfo.match(/客人名：(.+?);/g).toString().slice(4,-1),
                        CheckIn:CheckIn,
                        CheckOut:CheckOut,
                        CreationDate: this.filterDateLongline(list[i].CreationDate),
                        UseNum:list[i].UseNum,
                    };
                    l.push(lis)
                }
                
                return l
            },

            // filterDateToYMDline(date) {
            //     if (!date) return '';
            //     var da = new Date(date);
            //     var year = da.getFullYear();
            //     var month = da.getMonth() + 1;
            //     var day = da.getDate();
            //     if (month < 10) {
            //         month = '0' + month
            //     };
            //     if (day < 10) {
            //         day = '0' + day
            //     };
            //     return year + '-' + month + '-' + day;
            // },

            //日期期格式化为 0000-00-00 00:00:00
            filterDateLongline(date) {
                if (!date) return '';
                date.replace('T', '');

                var da = new Date(date);
                var year = da.getFullYear();

                var month = da.getMonth() + 1;
                var day = da.getDate();

                if (month < 10) { month = '0' + month };
                if (day < 10) { day = '0' + day };

                var hour = da.getHours();
                if (hour < 10) {
                    hour = '0' + hour;

                }
                var minutes = da.getMinutes();
                if (minutes < 10) {
                    minutes = '0' + minutes;

                }
                var second = da.getSeconds();
                if (second < 10) {
                    second = '0' + second;

                }
                return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + second;

            },

            handlePrev(){
                if(this.curPage>1){
                    this.curPage--;
                    this.getReceiptData()
                }else {
                    this.error({title:'提示',content:'当前为最前页'});
                }
            },


            handleNext(){
                if(this.curPage<this.allPage){
                    this.curPage++;
                    this.getReceiptData()
                }else {
                    this.error({title:'提示',content:'当前为最后页'});
                }
            },
            getReceiptData (flag) {
                let that = this
                if(flag){
                    this.curPage = 1
                }
                let param = {
                    Page: this.curPage,
                    PageSize: this.pageSize,
                    End: this.End,
                    Start: this.Start
                }
                
                that.isLoading = true
                //  发请求
                that.postRequest({
                    //  请求的url   api文件里面写的
                    url:that.Api.getReceipts,
                    params:param
                }).then(res => {
                    that.ReceiptList = []
                    if(res.IsSuccess){
                        //  如果成功了
                        that.isLoading = false
                        that.ReceiptList = res.Result
                        that.allPage = Math.ceil(res.Total/that.pageSize)
                        if(!res.Total){
                            that.curPage = 1
                            that.noneDataMsg='暂无数据...'
                        }else{
                            that.noneDataMsg=''
                        }
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    }else{
                        //  如果失败了
                        this.error({title:'提示',content:res.Msg||'保存失败'});
                    }
                });
            }
        }
    }
</script>

<style scoped>
.time {
    overflow: auto;
}

.time>input {
    text-align: center;
    padding: 5px 0;
    border: 1px solid #d1d1d1;
}

.time .timeSearch {
    float: right;
    padding: 10px 30px;
    color: #fff;
    cursor: pointer;
    background-color: #28c667;
}

.time .timeExcel{
    float: right;
    padding: 10px 30px;
    margin-left:20px; 
    background: #f5f5f5;
    color: #333;
    cursor: pointer;
}

.ellipsis{
    width: 360px;
    padding: 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/bill/ReceiptsBill.vue